import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { GraphService } from '../../General/graph/graph.service';
import { TreeService } from '../../General/Tree/tree.service';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { FindSimplePathGraph } from './find-simple-path-graph';
import { TreeWords } from './tree-words';
import { GraphExerciseComponent } from '../../shared/interactive-graph/exercise_components/graph-exercise.component';
import { InteractiveGraph } from 'graph-interactive/dist/lib/interactive/interactiveGraph';

@Component({
  selector: 'app-find-valid-path',
  templateUrl: './find-valid-path.component.html',
  styleUrls: ['./find-valid-path.component.css']
})
export class FindValidPathComponent extends GraphExerciseComponent {


  private tree: TreeWords;
  private canvas: HTMLCanvasElement;
  private treeCanvas: HTMLCanvasElement;
  private text: HTMLTextAreaElement;

  private readonly canvasID: string = 'graph-canvas';
  private readonly treeID: string = 'tree-canvas';
  private readonly graphService: GraphService;
  private readonly treeService: TreeService;


  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService,
    protected messageService: MessageService, graphService: GraphService, treeService: TreeService) {
    super(activatedRoute, topicService, messageService);
    this.graphService = graphService;
    this.treeService = treeService;
    this.printable = true;
    this.type = 'findSimplePath';
  }



  initGraph(): InteractiveGraph {
    const canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    const g = new FindSimplePathGraph(canvas);
    return g;
  }




  checkSolution() {
    if (this.graph instanceof FindSimplePathGraph) {
      let status: number = this.graph.checkSelectedPath(
        this.tree.getSelectedPaths(), this.tree.getAllPaths());
      if (status == 1) {
        this.messageService.addAlertWithTimeout("Richtig", 'success', 10000);
        this.solved = true;
        this.state.solved = true;
        this.saveState();
      }
      else if (status == -1) {
        this.messageService.addAlertWithTimeout("Falsch", 'danger', 10000);
      }
      else {
        this.messageService.addAlertWithTimeout("Du hast noch nicht alle gültigen Wege gefunden", 'danger', 10000);
      }
    }
  }

  setTypeSpecificsFromState() {
  }



  computeState() {

  }
  resetState() {
    super.resetState();
  }


  setTypeSpecificsFromConfiguration() {
    window.onload = function () { };
    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);

    this.treeCanvas = <HTMLCanvasElement>document.getElementById(this.treeID);
    let alphabet: [any[], number][] = this.treeService.importMultiTree(this.configuration);
    let hasRep: boolean = this.treeService.importHasRepetition(this.configuration);
    this.tree = new TreeWords(alphabet, hasRep, this.treeCanvas);
    this.tree.buildTree();

    let rootContent: any[] = this.treeService.importSubNode(this.configuration);
    if (rootContent.length > 0) {
      if (this.tree instanceof TreeWords) {
        this.tree.setSubNode(rootContent);
      }
    }
    this.tree.generateSimplePaths();
    this.tree.update();


  }

  evaluate(): [number, number] {
    if (this.graph instanceof FindSimplePathGraph) {
      let status: number = this.graph.checkSelectedPath(
        this.tree.getSelectedPaths(), this.tree.getAllPaths());
      if (status == 1) {
        return [1, 1];
      }
    }
    return [0, 1];
  }


}
